import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./delivery.module.scss";

const getPostfix = (value) => {
  return value === 1 || (value > 20 && (value + ``).slice(-1) === `1`)
    ? `дня`
    : `дней`;
};

function DeliveryList({items, isMoscow}) {
  return (
    <>
      {typeof items === `string` ? (
        items
      ) : (
        <div className={styles.table}>
          {items.express && (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Курьером
              </div>
              <div className={styles.cell}>
                От {items.express.min_delivery_term}
                {` `}
                {getPostfix(items.express.min_delivery_term)}
              </div>
              <div className={styles.cell}>{items.express.cost}₽</div>
            </div>
          )}
          {Object.keys(items.pickup).length ? (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Пункт выдачи
              </div>
              <div className={styles.cell}>
                От {Math.min(...items.pickup.min_terms)}
                {` `}
                {getPostfix(Math.min(...items.pickup.min_terms))}
              </div>
              <div className={styles.cell}>
                от {Math.min(...items.pickup.costs)}₽
              </div>
            </div>
          ) : null}
          {isMoscow ? (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Самовывоз с Таганской
              </div>
              <div className={styles.cell}>от 1 дня</div>
              <div className={styles.cell}>0₽</div>
            </div>
          ) : null}
          {items.lightning && (
            <div className={styles.row}>
              <div className={classNames(styles.cell, styles.headCell)}>
                Молния
              </div>
              <div className={styles.cell}>Сегодня</div>
              <div className={styles.cell}>{items.lightning.cost}₽</div>
            </div>
          )}
        </div>
      )}
    </>
  );
}

DeliveryList.propTypes = {
  items: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  isMoscow: PropTypes.bool
};

export default DeliveryList;
